# import { default as WebModule__Content } from 'models/modulor/web_module/content'
#
# export class FeaturedPost extends WebModule__Content
#   @defaults =
#     debug: false
#     name: 'FeaturedPostModule'
#
#   @selector: ".featured_post_module"
#
#   on_init: ->
#     console.log 'init' if @options.debug
#
# FeaturedPost.register()
